import { render, staticRenderFns } from "./OpenProjectDialog.vue?vue&type=template&id=dccbf8d4&scoped=true"
import script from "./OpenProjectDialog.vue?vue&type=script&lang=js"
export * from "./OpenProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./OpenProjectDialog.vue?vue&type=style&index=0&id=dccbf8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccbf8d4",
  null
  
)

export default component.exports